import { render, staticRenderFns } from "./Pdf-Viewer.vue?vue&type=template&id=c2a7c434&"
import script from "./Pdf-Viewer.vue?vue&type=script&lang=ts&"
export * from "./Pdf-Viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports